// Shared intensity thresholds so every consumer that decides "is this
// motivation actually being pushed?" cannot drift apart.
//
// Both motivation sources (Game & Live Events, Creative Ads) live on a 1–5
// scale. Measured on the current dataset:
//
//   Game & Live Events  median 2.15  p75 3.22  p90 4.13
//   Creative Ads        median 1.77  p75 2.56  p90 3.29
//
// The threshold below is picked so the diagnosis section actually surfaces
// meaningful cards while staying robust to the source's low-skewed shape:
//   MEDIUM ≈ "above the median of either source — registering as more than
//             background noise"
export const INTENSITY_MEDIUM_MIN = 2
